import { CustomNotification } from '@/models/custom-notification.model';
import { MutationTree } from 'vuex';
import { NotificationState } from './types';

export const mutations: MutationTree<NotificationState> = {
    addNotification(state: NotificationState, notification: CustomNotification) {
        state.notifications = [notification, ...state.notifications];
    },
    removeNotification(state: NotificationState, notificationUuid: string) {
        state.notifications = state.notifications.filter((notification: CustomNotification) => {
            return notification.uuid !== notificationUuid;
        });
    },
    clearNotifications(state: NotificationState) {
        state.notifications = [];
    },
};
